import "./StackPanelStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";


export interface IStackPanelOptions {
    orientation?: "horizontal" | "vertical";
    valign?: "center" | "stretch" | "top" | "bottom" | "baseline";
    responsive?: boolean;
    sizes?: string[];
    wrap?: boolean;
}

export class StackPanelComponent implements IJSLComponent {

    private options: IStackPanelOptions;

    public constructor(private children: Array<IJSLVNode | IJSLComponent>, options?: IStackPanelOptions) {
        this.options = { ...{ orientation: "horizontal", valign: "stretch" }, ...options };
    }

    public isEqual(node: IJSLComponent): boolean {
        return (this as any).__proto__ === (node as any).__proto__;
    }

    public render(): IJSLVNode {
        let c = this.options.orientation === "horizontal" ? "stackpanel-comp hstackpanel" : "stackpanel-comp vstackpanel";
        if (this.options.responsive) {
            c += " responsive";
        }
        if (this.options.wrap) {
            c += " wrap";
        }
        const va = this.options.valign;
        const s = "align-items:" +  (va === "top" ? "flex-start" : (va === "bottom" ? "flex-end" : va));
        return {
            tag: "div", attr: { class: c, style: s },
            children: this.children.map((x, idx) => x != null && (x as any)._is_splitter === true ? x : ({
                tag: "div",
                attr: { style: this.getSize(idx) },
                children: [x]
            })
            )
        };
    }

    private getSize(idx: number): string {
        if (this.options.sizes != null && this.options.sizes[idx] != null) {
            const s = this.options.sizes[idx];
            if (s === "*") {
                return undefined;
            }
            return "width:" + s;
        }
        return "flex-grow:1;";
    }

}
